import { inject } from 'vue';
import { eventSeriesKey } from '../keys';

export function useEventSeriesInjection() {
    const eventSeriesInjection = inject(eventSeriesKey);
    if (!eventSeriesInjection) {
        throw new Error('event series not properly injected');
    }
    return eventSeriesInjection;
}
